import { render, staticRenderFns } from "./MemberPurposeComponent.vue?vue&type=template&id=1fcd2b94&"
import script from "./MemberPurposeComponent.vue?vue&type=script&lang=js&"
export * from "./MemberPurposeComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports